import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

import Top from '../navigation/top';
import { FormRow } from '../form/formField';

const initialState = {};

const FIELDS = {
    brandno: { label: 'brand #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    name: { label: 'brand name', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    fullName: { label: 'brand fullName', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    showOnConsumerWeb: { label: 'Show on ConsumerWeb', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    showOnDealerWeb: { label: 'Show on DealerWeb', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },

    sort: { label: 'sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    count: { label: 'count', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    countPresale: { label: 'countPresale', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class BrandEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { brandStore } = this.props.stores;
        brandStore.load(props.brandid);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['brandno', 'name', 'fullName', 'sort', 'count', 'countPresale', 'updatedDate'].map(f => util.makeField(f, FIELDS)),
            },
        ];
    }

    updateField = async (id, field, value) => {
        const { brandStore } = this.props.stores;
        brandStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { brandStore } = this.props.stores;
        await brandStore.saveField(id, field, value);
    }

    render(props) {
        const { brandStore } = this.props.stores;
        const { brand, saved } = brandStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/brands' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {brand.id}: {brand.name}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/brands/${props.brandid}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={brand}
                            saved={saved}
                            updateField={this.updateField}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default BrandEdit;



// WEBPACK FOOTER //
// ./components/brands/edit.js